/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.1.0
 */

import { SagaIterator } from 'redux-saga';
import { put, select, takeEvery } from 'redux-saga/effects';

import { loadTableListAction } from '../../components/Table/actions/tableActions';
import { pushGTMAnalytic } from '../analytics/GoogleTagManager/GTMActions';
import GTMOperations from '../analytics/GoogleTagManager/GTMOperations';
import { makeSelectTranslationCommon } from '../internationalization/intSelectors';
import { ICommonTranslationListsDensityListView } from '../internationalization/types/common/lists';
import { ICommonTranslationPages } from '../internationalization/types/common/pages';
import { setCookie } from '../storage/storageActions';
import { ECookieKey } from '../storage/storageTypes';
import { SET_DENSITY_LIST_VIEW } from './densityConstants';
import { IDensityListViewAction } from './densityTypes';

const getGtmMenuName = (page: string, translation: ICommonTranslationPages): string => {
    // @ts-ignore
    return translation[page] || '';
};
const getGtmParam = (value: boolean, translation: ICommonTranslationListsDensityListView): string => {
    return translation.gtmParam + (value ? translation.compact : translation.default);
};

export function* setDensityListViewSaga(action: IDensityListViewAction): SagaIterator {
    yield put(setCookie({
        key: ECookieKey.DENSITY_LIST_VIEW,
        value: action.payload.value,
        options: {
            'max-age': '7776000', // 3 months
        },
    }));
    yield put(loadTableListAction({ force: true }));

    // GTM
    const translationCommon = yield select(makeSelectTranslationCommon());
    const gtmMenu = getGtmMenuName(action.payload.page, translationCommon.pages);
    const gtmParam = getGtmParam(action.payload.value, translationCommon.lists.densityListView);

    yield put(pushGTMAnalytic({
        operation: GTMOperations.userSettings.onClickDensityListView(gtmParam, gtmMenu),
        withAccountType: true,
        withSusrId: true,
        withUserRole: true,
    }));
}

export function* densitySagas() {
    yield takeEvery(SET_DENSITY_LIST_VIEW, setDensityListViewSaga);
}
